import { Code, Key } from 'lucide-react';
import { PageHeader, GettingStarted, QuickLinksGrid } from '../components/landing';
import { DASHBOARD_URL } from '../config/platformUrls';
import { useContext } from 'react';
import { AuthContext } from '../components/auth/AuthProvider';
import { createCrossOriginAuthUrl } from '../utils/authSync';

export default function DeveloperLanding() {
  const { session } = useContext(AuthContext);

  const handleDashboardLink = () => {
    const authUrl = createCrossOriginAuthUrl(DASHBOARD_URL, session);
    window.open(authUrl, '_blank');
  };

  const quickLinks = [
    {
      title: 'API Keys',
      description: 'Manage your API keys and access credentials',
      href: '/api-keys',
      icon: Key,
    },
    {
      title: 'API Documentation',
      description: 'Explore our comprehensive API documentation',
      href: 'https://docs.jua.ai',
      icon: Code,
      external: true,
    },
  ];

  const gettingStartedSteps = [
    {
      title: 'Get API Keys',
      description: 'Generate and manage your API credentials',
    },
    {
      title: 'Explore Documentation',
      description: 'Read our comprehensive API documentation',
    },
    {
      title: 'Monitor Performance',
      description: 'Track your API usage and model performance',
    },
  ];

  const isLinkAccessible = () => {
    return true;
  };

  const isLinkVisible = () => {
    return true;
  };

  return (
    <div className="max-w-6xl mx-auto p-6 sm:p-8 lg:pl-12">
      <PageHeader
        title="Jua Developer Platform"
        description="Welcome to the Jua Developer Platform. Access our APIs, technical documentation, and developer tools to integrate weather intelligence into your applications."
      />

      <GettingStarted
        title="Getting Started"
        description="New to the platform? Here's how to get started with our developer tools:"
        steps={gettingStartedSteps}
      />

      <QuickLinksGrid
        title="Quick Access"
        links={quickLinks}
        isLinkAccessible={isLinkAccessible}
        isLinkVisible={isLinkVisible}
      />

      <div className="mt-12 p-6 bg-gray-50 rounded-lg">
        <h3 className="text-lg font-semibold mb-2">Looking for the User Dashboard?</h3>
        <p className="text-gray-600 mb-4">
          Access weather forecasts, market data, and user-friendly analytics in our main dashboard.
        </p>
        <button
          onClick={handleDashboardLink}
          className="inline-flex items-center text-[#E34290] hover:text-[#C93B7D] font-medium"
        >
          Go to User Dashboard
          <svg
            className="ml-2 w-4 h-4"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
            />
          </svg>
        </button>
      </div>
    </div>
  );
}
